import { Button, NoDataFound } from "components"
import { Box } from "theme-ui"
interface ITableModelRow {
 data?: any[]
 popup?: boolean
 setPopup?: (..._arg: boolean | any) => void
 serverDeviceName?: string
}
export const TableModelRow = ({ data, popup, setPopup, serverDeviceName }: ITableModelRow) => {
 return popup ? (
  <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
   <div className="fixed inset-0 z-10 w-screen overflow-y-scroll">
    <div className="fixed top-5 inset-0 bg-black bg-opacity-50 flex h-screen items-end justify-center p-4 text-center sm:items-center sm:p-0">
     <Box bg="highlight" className="relative transform overflow-hidden rounded-lg  text-left shadow-xl transition-all sm:w-full sm:max-w-2xl h-[75vh] pb-5">
      <Box
       bg="highlight"
       className="flex justify-between items-center px-4 pb-4 pt-5 sm:p-6 sm:pb-4"
      >
       <div className="sm:flex font-bold sm:items-start">
        {serverDeviceName && serverDeviceName}
       </div>
       <div>
        <Button size={"sm"} color={"white"} onClick={() => setPopup && setPopup(false)}>
         Close
        </Button>
       </div>
      </Box>

      <div className="px-4 py-3 sm:px-4 overflow-y-scroll h-[65vh]">
       <div className="">
        {data?.length ? (
         data?.map((item, index) => (
          <>
           <p className="bg-golden rounded p-3 font-bold">
            {`block  ${index + 1}: ${item?.block_title}`}
           </p>
           <Box bg="highlight" className="flex px-3 py-2 text-xs rounded">
            <p className="w-1/4 font-bold ">Version</p>
            <p className="">{item?.version}</p>
           </Box>

           <Box bg="light_gray" className="flex px-3 py-2 text-xs bg-gray rounded">
            <p className="w-1/4 font-bold">OCIT-I checksum</p>
            <p className="">{item?.ocit_i_checksum}</p>
           </Box>
           <Box bg="highlight" className="flex px-3 py-2 text-xs bg-white rounded">
            <p className="w-1/4 font-bold">Build Nr</p>
            <p className="">{item?.build_number}</p>
           </Box>
           <Box bg="light_gray" className="flex px-3 py-2 text-xs bg-gray rounded">
            <p className="w-1/4 font-bold">Activation time</p>
            <p className="">{item?.activation_time}</p>
           </Box>
           <Box bg="highlight" className="flex px-3 py-2 text-xs bg-white rounded">
            <p className="w-1/4 font-bold">Transmission time</p>
            <p className="">{item?.transmission_time}</p>
           </Box>
           <Box bg="light_gray" className="flex px-3 py-2 text-xs bg-gray rounded">
            <p className="w-1/4 font-bold ">Origin</p>
            <p className="">{item?.origin}</p>
           </Box>
           <Box bg="highlight" className="flex px-3 py-2 text-xs bg-white rounded">
            <p className="w-1/4 font-bold">System object ID</p>
            <p className="">{item?.system_object_id}</p>
           </Box>
           <Box bg="light_gray" className="rounded">
            <div className="flex px-3 py-2 text-xs mb-5">
             <p className="w-1/4 font-bold">OCIT-O checksum</p>
             <p className="">{item?.ocit_o_checksum}</p>
            </div>
           </Box>
          </>
         ))
        ) : (
         <NoDataFound />
        )}
       </div>
      </div>
     </Box>
    </div>
   </div>
  </div>
 ) : (
  <></>
 )
}
